/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initReferralTiers(sectionId) {
  var $section = $('#referral-tiers-' + sectionId);
  if (!$section.length) return;

  var $text = $section.find('.referral-tiers__text');
  var $tiers = $section.find('.referral-tiers__tier');
  var $nav = $section.find('.referral-tiers__nav');
  var $cta = $section.find('.referral-tiers__cta');

  function showInstantly($elements) {
    $elements.each(function() {
      if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(this);
      $(this).css({ visibility: 'visible', opacity: 1, transform: 'none' });
    });
  }

  if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
    if ($text.length) {
      ScrollReveal().reveal($text[0], {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }

    if ($tiers.length) {
      $tiers.each(function(i, el) {
        ScrollReveal().reveal(el, {
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          delay: 0 + (i * 40),
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          opacity: 0,
          scale: 1,
          once: true
        });
      });
    }

    if ($nav.length) {
      ScrollReveal().reveal($nav[0], {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }

    if ($cta.length) {
      ScrollReveal().reveal($cta[0], {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 0,
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    }
  } else {
    showInstantly($text.add($tiers).add($nav).add($cta));
  }
}

$(function() {
  var instances = window.DeskReferralTiers || {};
  $.each(instances, function(id) {
    initReferralTiers(id);
  });
});
